import { SERVER_URL } from "../../../../utils";

/** Normaliza rutas guardadas (p. ej. uploads\\users\\... en Windows). */
export function normalizeEscapeRoomMediaPath(url) {
	if (url == null || typeof url !== "string") return "";
	let u = url.trim().replace(/\\/g, "/");
	if (!u) return "";
	const lower = u.toLowerCase();
	const uploadsIdx = lower.indexOf("uploads/");
	if (uploadsIdx > 0) u = u.slice(uploadsIdx);
	return u;
}

/** URL absoluta para mostrar imágenes/vídeos del escape room en el editor y en juego. */
export function resolveEscapeRoomMediaUrl(url) {
	const u = normalizeEscapeRoomMediaPath(url);
	if (!u) return "";
	if (/^(https?:|data:|blob:)/i.test(u)) return u;
	if (u.startsWith("/")) return u;
	const base = String(SERVER_URL || "").replace(/\/$/, "");
	return `${base}/${u.replace(/^\//, "")}`;
}
